// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".c-error__container[data-v-b89dfe82]{padding:10px 15px;border:1px solid var(--v-error-lighten4);border-radius:4px;display:inline-flex;justify-content:space-between}.c-error__list[data-v-b89dfe82]{margin:0 20px 0 12px;padding:0;list-style-type:none;font-size:14px;color:var(--v-error-base)}.c-error__item[data-v-b89dfe82]{display:flex;align-items:center}.c-error__item+.c-error__item[data-v-b89dfe82]{margin-top:8px}", ""]);
// Exports
module.exports = exports;
